module.exports = __webpack_public_path__ + "static/media/1.959b901d.png";